export const CALGARY_LAT_LNG = {
  latitude: 51.0447,
  longitude: -114.0719,
};
